<!-- <ng-container *ngIf="desktop | async"> -->
  <!-- <app-header *ngIf="showHeader | async"></app-header> -->
  <!-- <app-header></app-header> -->
<!-- </ng-container> -->
 <!-- <app-page>

 </app-page> -->

 <!-- Mobile Header -->
<app-mobile-header 
  *ngIf="showMobileHeader | async"
  (menuToggle)="toggleMobileMenu()">
</app-mobile-header>

<!-- Mobile Menu -->
<app-mobile-menu 
  [isOpen]="isMobileMenuOpen | async"
  (closeMenu)="closeMobileMenu()">
</app-mobile-menu>

<div class="main-content" role="main">
  <router-outlet></router-outlet>
</div>
<div #footer></div>
<ng-container *ngIf="showFooter | async">
  <!-- @defer { -->
    <app-directory></app-directory>
    <app-footer></app-footer>
  <!-- } @placeholder {
    <div></div>
  } -->
</ng-container>

<ng-container *ngIf="isBrowser">
  <ng-container *ngIf="login | async">
    <div class="login-backdrop">
      <div class="login-modal" @fadeIn (outsideClick)="close()">
        <div class="close-button-wrapper" (click)="close()">
          <svg-icon [svgStyle]="{'width.px': 18, 'height.px': 18}" src="assets/icons/x.svg"></svg-icon>
        </div>
        <div class="logo">
          <app-logo></app-logo>
        </div>
        <div class="message">
          <ng-container i18n class="title">Web app coming soon!</ng-container>
          <div class="content">
            <ng-container i18n class="text">
              Come back to access our full catalogue of hostels. We will be launching to travelers in spring 2024. Sign up to our newsletter to find out more about our release date and how you can save on bookings with Hostel Hop.
            </ng-container>
            <div class="form">
              <input placeholder="Email" class="input-inline" [(ngModel)]="email" />
            </div>
          </div>
        </div>
        <div class="button-wrapper">
          <button class="btn btn-theme btn-large" (click)="inviteBackpacker()">
            <span>Stay updated</span>
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="showLocaleModal$ | async">
    <div class="login-backdrop">
      <app-locale-modal @fadeIn (outsideClick)="closeLocaleModal()"></app-locale-modal>
    </div>
  </ng-container>
</ng-container>

<!-- FlixBus promotion - works on all platforms (mobile and desktop) -->
<app-flixbus-promotion *ngIf="(showPromotion | async) && !(homeTrip.active$ | async)" @fadeIn></app-flixbus-promotion>

<app-seo></app-seo>

<app-launch-video></app-launch-video>
